export const MIN_CHECKOUT_SOURCE_QUANTITY = 2;
export const MAX_CHECKOUT_SOURCE_QUANTITY = 1000;
